import { EventApi } from "../lib-api/apis/EventApi";
import { apiConfiguration } from "../api-configuration";
import { isBot } from "../util/browser-detection";

type EventObject = {
  ikpi?: string;
  objectId?: string;
  objectType?: string;
};

let impressionEventObserver: IntersectionObserver | null = null;
const queue: EventObject[] = [];
const eventApi = new EventApi(apiConfiguration);

if ("IntersectionObserver" in window && !isBot()) {
  impressionEventObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const eventElement = entry.target as HTMLElement;
          queue.push({
            ikpi: eventElement.dataset.ikpi,
            objectId: eventElement.dataset.objectid,
            objectType: eventElement.dataset.objecttype,
          });
          impressionEventObserver?.unobserve(eventElement);
        }
      });
    },
    { threshold: 0.5 }
  );

  //Ville gerne finde på noget bedre end dette. Kan man hooke up på et array? Detecte changes?
  //Idéen er at kunne bundle flere impressions i et api kald. F.eks. på forsiden vil der muligvis være 3 banner above the fold, 1 api kald i stedet for 3!
  // /api/impr/tr { ids: ['asd-asd-asd-as-d', 'dsa-dsaas-d-as-asdsa-d'] }
  const pushQueue = () => {
    setTimeout(async () => {
      if (queue.length > 0) {
        const toPush = queue.splice(0, queue.length);
        //upload queue and reset it
        try {
          (async () => {
            toPush.forEach((event) => {
              if (event.ikpi && event.objectId && event.objectType) {
                trackVoresKpi(event.ikpi, event.objectId, event.objectType);
              }
            });
          })();
        } catch (e) {
          console.error(e);
        }
      }
      pushQueue();
    }, 500); //hvor tit kan vi polle?
  };
  pushQueue();
}

export const trackVoresKpi = async (eventType, objectId, objectType) => {
  await eventApi.trackEvent({
    eventTypeString: eventType,
    objectId: objectId,
    objectTypeString: objectType,
  });
};

const getClickTrackingElements = (el?: ParentNode) =>
  (el || document).querySelectorAll<HTMLElement>("a[data-ckpi]");
const getImpressionTrackingElements = (el?: ParentNode) =>
  (el || document).querySelectorAll<HTMLAnchorElement>("[data-ikpi]");

export function hookVoresEventTracking(el?: ParentNode) {
  getClickTrackingElements(el).forEach(function (element) {
    if (
      element.dataset.ckpi &&
      element.dataset.objectid &&
      element.dataset.objecttype
    ) {
      // console.log(element.dataset.ckpi);
      // console.log(element.dataset.objectid);
      // console.log(element.dataset.objecttype);
      element.addEventListener("click", () => {
        (async () => {
          trackVoresKpi(
            element.dataset.ckpi,
            element.dataset.objectid,
            element.dataset.objecttype
          );
        })();
      });
    }
  });
  getImpressionTrackingElements(el).forEach(function (element) {
    impressionEventObserver && impressionEventObserver.observe(element);
  });
}
